module.exports = __webpack_public_path__ + "img/copy.ai.d5fc568f.svg";